<template>
  <div class="moment-page">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>

      <div class="page-wrapper">
        <div class="content container-fluid moment-page-content">
          <div class="moment-page-head">
            <div class="moment-head-copy">
              <span class="moment-eyebrow">
                <i class="fa fa-gift"></i>
                Otomasi Pelanggan
              </span>
              <h3 data-tour-step="1">Momen Spesial</h3>
              <p>Jadwalkan ucapan dan promo otomatis untuk pelanggan di hari spesial mereka.</p>
              <ul class="breadcrumb">
                <li class="breadcrumb-item">
                  <router-link to="/index">Dashboard</router-link>
                </li>
                <li class="breadcrumb-item active">Momen Spesial</li>
              </ul>
            </div>

            <button
              type="button"
              class="btn moment-btn moment-btn-primary"
              :class="{ 'is-disabled': !isConfigured }"
              data-tour-step="2"
              :title="isConfigured ? 'Tambah Momen Spesial' : 'Aktifkan pengiriman otomatis terlebih dahulu'"
              @click="openAddMoment"
            >
              <i class="fa fa-plus"></i>
              Tambah Momen
            </button>
          </div>

          <schedule
            :dataDetailStatus="dataDetailStatus"
            :detailStatus="detailStatus"
          />

          <div v-if="statusError" class="moment-inline-note is-error">
            <span><i class="fa fa-exclamation-circle"></i> {{ statusError }}</span>
            <button type="button" class="moment-link-btn" @click="detailStatus">Coba Lagi</button>
          </div>

          <div class="moment-stat-grid">
            <div class="moment-stat-card">
              <span class="moment-stat-icon is-orange"><i class="fa fa-calendar"></i></span>
              <div class="moment-stat-copy">
                <span>Total Momen</span>
                <strong>
                  <i v-if="summaryLoading" class="fa fa-spinner fa-spin"></i>
                  <template v-else>{{ formatNumber(summaryTotal) }}</template>
                </strong>
                <small>momen tersimpan</small>
              </div>
            </div>

            <div class="moment-stat-card">
              <span class="moment-stat-icon is-green"><i class="fa fa-paper-plane"></i></span>
              <div class="moment-stat-copy">
                <span>Published</span>
                <strong>
                  <i v-if="summaryLoading" class="fa fa-spinner fa-spin"></i>
                  <template v-else>{{ formatNumber(summaryPublished) }}</template>
                </strong>
                <small>siap dikirim otomatis</small>
              </div>
            </div>

            <div class="moment-stat-card">
              <span class="moment-stat-icon is-amber"><i class="fa fa-file-o"></i></span>
              <div class="moment-stat-copy">
                <span>Draft</span>
                <strong>
                  <i v-if="summaryLoading" class="fa fa-spinner fa-spin"></i>
                  <template v-else>{{ formatNumber(summaryDraft) }}</template>
                </strong>
                <small>menunggu ditinjau</small>
              </div>
            </div>

            <div class="moment-stat-card">
              <span class="moment-stat-icon is-blue"><i class="fa fa-clock-o"></i></span>
              <div class="moment-stat-copy">
                <span>Pengiriman otomatis</span>
                <strong :class="isScheduleEnabled ? 'stat-on' : 'stat-off'">
                  <i v-if="dataDetailStatus === null" class="fa fa-spinner fa-spin"></i>
                  <template v-else>{{ isScheduleEnabled ? "Aktif" : "Nonaktif" }}</template>
                </strong>
                <small>{{ scheduleTime ? "Setiap hari " + scheduleTime + " WIB" : "Jadwal belum diatur" }}</small>
              </div>
            </div>
          </div>

          <div v-if="summaryError" class="moment-inline-note is-warning">
            <span><i class="fa fa-exclamation-circle"></i> {{ summaryError }}</span>
            <button type="button" class="moment-link-btn" :disabled="summaryLoading" @click="loadSummary">
              Coba Lagi
            </button>
          </div>
          <div v-else-if="summaryIncomplete" class="moment-inline-note">
            <span>
              <i class="fa fa-info-circle"></i>
              Sebagian statistik belum dapat dihitung karena jumlah momen melebihi batas data yang dimuat.
            </span>
            <button type="button" class="moment-link-btn" :disabled="summaryLoading" @click="loadSummary">
              Muat Ulang
            </button>
          </div>

          <section class="moment-card moment-toolbar" data-tour-step="3">
            <div class="moment-toolbar-row">
              <div class="moment-search">
                <i class="fa fa-search"></i>
                <input
                  v-model="serverParams.columnFilters.message"
                  type="text"
                  placeholder="Cari isi pesan momen..."
                  aria-label="Cari isi pesan momen"
                  autocomplete="off"
                  @keyup.enter="searchData"
                />
                <button
                  v-if="serverParams.columnFilters.message"
                  type="button"
                  class="moment-search-clear"
                  title="Bersihkan pencarian"
                  aria-label="Bersihkan pencarian"
                  @click="clearMessageSearch"
                >
                  <i class="fa fa-times"></i>
                </button>
              </div>

              <div class="moment-license-filter">
                <multiselect
                  v-model="selectedLicense"
                  :options="contactOptions"
                  label="license_name"
                  track-by="id"
                  :multiple="false"
                  :searchable="true"
                  :internal-search="false"
                  :loading="isLoadingLicense"
                  :close-on-select="true"
                  :allow-empty="true"
                  :custom-label="licenseLabel"
                  placeholder="Semua Lisensi"
                  @search-change="asyncFindLicense"
                >
                  <template slot="option" slot-scope="{ option }">
                    <span>
                      {{ option.license_name }}
                      <small v-if="option.license_phone_number" class="moment-option-phone">
                        {{ option.license_phone_number }}
                      </small>
                    </span>
                  </template>
                  <span slot="noResult">Lisensi tidak ditemukan.</span>
                </multiselect>
              </div>

              <div class="moment-status-filter">
                <select
                  v-model="serverParams.columnFilters.is_publish"
                  aria-label="Filter status momen"
                  @change="searchData"
                >
                  <option value="">Semua Status</option>
                  <option value="publish">Published</option>
                  <option value="draft">Draft</option>
                </select>
              </div>

              <button type="button" class="btn moment-btn moment-btn-primary" @click="searchData">
                <i class="fa fa-search"></i>
                Cari
              </button>
              <button
                v-if="isFilterActive"
                type="button"
                class="btn moment-btn moment-btn-secondary"
                @click="resetFilters"
              >
                <i class="fa fa-refresh"></i>
                Reset
              </button>
            </div>

            <div v-if="selectedTable.length" class="moment-bulk-bar">
              <span><strong>{{ selectedTable.length }}</strong> momen dipilih</span>
              <button type="button" class="btn moment-btn moment-btn-secondary" :disabled="isLoading" @click="actionDraft">
                <i class="fa fa-pause"></i>
                Draft
              </button>
              <button type="button" class="btn moment-btn moment-btn-primary" :disabled="isLoading" @click="actionPublish">
                <i class="fa fa-check"></i>
                Publish
              </button>
              <button type="button" class="btn moment-btn moment-btn-danger" :disabled="isLoading" @click="actionDelete">
                <i class="fa" :class="isLoading ? 'fa-spinner fa-spin' : 'fa-trash'"></i>
                Hapus
              </button>
              <button type="button" class="btn moment-btn moment-btn-ghost" @click="hideActions">Batal</button>
            </div>
          </section>

          <section class="moment-card moment-table-card">
            <div class="moment-table-wrap">
              <table class="table moment-table mb-0">
                <thead>
                  <tr>
                    <th class="moment-check-col">
                      <input
                        v-model="selectAllTable"
                        type="checkbox"
                        :disabled="loading || !rows.length"
                        title="Pilih semua momen pada halaman ini"
                        aria-label="Pilih semua momen pada halaman ini"
                      />
                    </th>
                    <th>Momen</th>
                    <th class="moment-license-col">Lisensi</th>
                    <th class="moment-schedule-col">Jadwal</th>
                    <th>Status</th>
                    <th v-if="hasUpdateDates" class="moment-updated-col">Terakhir Diperbarui</th>
                    <th class="moment-action-col">Aksi</th>
                  </tr>
                </thead>

                <tbody>
                  <template v-if="loading">
                    <tr v-for="index in 5" :key="'moment-skeleton-' + index">
                      <td :colspan="tableColumnCount">
                        <div class="moment-skeleton-row">
                          <span class="moment-skeleton moment-skeleton-check"></span>
                          <span class="moment-skeleton moment-skeleton-name"></span>
                          <span class="moment-skeleton moment-skeleton-message"></span>
                        </div>
                      </td>
                    </tr>
                  </template>

                  <template v-else-if="rows.length">
                    <tr v-for="row in rows" :key="row.id">
                      <td class="moment-check-col">
                        <input
                          v-model="selectedTable"
                          type="checkbox"
                          :value="row"
                          :aria-label="'Pilih momen ' + displayName(row)"
                        />
                      </td>
                      <td>
                        <div class="moment-name">{{ displayName(row) }}</div>
                        <div class="moment-message" v-html="messageSnippet(row)"></div>
                        <button
                          v-if="isLongMessage(row)"
                          type="button"
                          class="moment-message-more"
                          @click="showMessage(row)"
                        >
                          Lihat pesan lengkap
                        </button>
                        <div class="moment-mobile-meta">
                          <span v-if="row.license_name">
                            <i class="fa fa-building-o"></i>
                            {{ row.license_name }}
                          </span>
                          <span>
                            <i class="fa fa-clock-o"></i>
                            {{ scheduleLabel(row) }}
                          </span>
                          <span v-if="updatedAt(row)">
                            <i class="fa fa-calendar"></i>
                            Diperbarui {{ lastUpdated(row) }}
                          </span>
                        </div>
                      </td>
                      <td class="moment-license-col">
                        <div class="moment-license-name">{{ row.license_name || "—" }}</div>
                        <small v-if="row.license_phone_number" class="moment-license-phone">
                          {{ row.license_phone_number }}
                        </small>
                      </td>
                      <td class="moment-schedule-col">
                        <span class="moment-schedule">
                          <i class="fa fa-clock-o"></i>
                          {{ scheduleLabel(row) }}
                        </span>
                      </td>
                      <td>
                        <span class="moment-status-badge" :class="row.is_publish == 1 ? 'is-published' : 'is-draft'">
                          <i class="fa" :class="row.is_publish == 1 ? 'fa-check' : 'fa-save'"></i>
                          {{ row.is_publish == 1 ? "Published" : "Draft" }}
                        </span>
                      </td>
                      <td v-if="hasUpdateDates" class="moment-updated-col">
                        <span class="moment-updated">{{ lastUpdated(row) }}</span>
                      </td>
                      <td class="moment-action-col">
                        <div class="dropdown moment-row-actions">
                          <button
                            type="button"
                            class="moment-action-toggle"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                            title="Aksi momen"
                            aria-label="Aksi momen"
                          >
                            <i class="fa fa-ellipsis-h"></i>
                          </button>
                          <div class="dropdown-menu dropdown-menu-right">
                            <button
                              v-if="row.is_publish == 1"
                              type="button"
                              class="dropdown-item"
                              @click="draftData(row)"
                            >
                              <i class="fa fa-pause text-warning"></i>
                              Set to Draft
                            </button>
                            <button
                              v-else
                              type="button"
                              class="dropdown-item"
                              @click="publishData(row)"
                            >
                              <i class="fa fa-check text-success"></i>
                              Set to Publish
                            </button>
                            <button type="button" class="dropdown-item" @click="detailData(row.id)">
                              <i class="fa fa-pencil text-primary"></i>
                              Edit
                            </button>
                            <button type="button" class="dropdown-item" @click="copyData(row.id)">
                              <i class="fa fa-copy text-info"></i>
                              Duplikasi
                            </button>
                            <button type="button" class="dropdown-item" @click="showMessage(row)">
                              <i class="fa fa-eye text-info"></i>
                              Lihat Pesan
                            </button>
                            <div class="dropdown-divider"></div>
                            <button type="button" class="dropdown-item moment-danger-item" @click="deleteData(row)">
                              <i class="fa fa-trash text-danger"></i>
                              Hapus
                            </button>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </template>

                  <tr v-else-if="!loadError">
                    <td :colspan="tableColumnCount">
                      <div class="moment-empty">
                        <span class="moment-empty-icon"><i class="fa fa-gift"></i></span>
                        <strong>Belum ada Momen Spesial</strong>
                        <p>Buat ucapan atau promo pertama untuk pelanggan di hari spesial mereka.</p>
                        <button type="button" class="btn moment-btn moment-btn-primary" @click="openAddMoment">
                          <i class="fa fa-plus"></i>
                          Tambah Momen
                        </button>
                      </div>
                    </td>
                  </tr>

                  <tr v-else>
                    <td :colspan="tableColumnCount">
                      <div class="moment-empty">
                        <span class="moment-empty-icon is-error"><i class="fa fa-exclamation-circle"></i></span>
                        <strong>Data momen belum dapat dimuat</strong>
                        <p>{{ loadError }}</p>
                        <button type="button" class="btn moment-btn moment-btn-secondary" :disabled="loading" @click="reloadData">
                          <i class="fa fa-refresh"></i>
                          Coba Lagi
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="moment-pagination">
              <div class="moment-pagination-info">
                <span>
                  Menampilkan <strong>{{ rangeStart }}</strong>–<strong>{{ rangeEnd }}</strong>
                  dari <strong>{{ totalRecords }}</strong> momen
                </span>
                <label class="moment-per-page">
                  <span>Tampilkan</span>
                  <select v-model.number="serverParams.perPage" aria-label="Jumlah momen per halaman" @change="onPerPageChange">
                    <option :value="10">10</option>
                    <option :value="20">20</option>
                    <option :value="30">30</option>
                    <option :value="50">50</option>
                  </select>
                  <span>per halaman</span>
                </label>
              </div>

              <div class="moment-pagination-buttons">
                <button type="button" class="moment-page-btn" :disabled="currentPage <= 1" title="Halaman sebelumnya" @click="onPrevChange">
                  <i class="fa fa-angle-left"></i>
                </button>
                <button
                  v-for="page in pageNumbers"
                  :key="'moment-page-' + page"
                  type="button"
                  class="moment-page-btn"
                  :class="{ active: page === currentPage }"
                  :aria-current="page === currentPage ? 'page' : null"
                  @click="onPageChange(page)"
                >
                  {{ page }}
                </button>
                <button type="button" class="moment-page-btn" :disabled="currentPage >= totalPages" title="Halaman berikutnya" @click="onNextChange">
                  <i class="fa fa-angle-right"></i>
                </button>
              </div>
            </div>
          </section>

          <div class="moment-page-note">
            <i class="fa fa-info-circle"></i>
            Status Draft dapat ditinjau sebelum dipublikasikan. Pengiriman mengikuti jadwal otomatis yang aktif.
          </div>
        </div>
      </div>
    </div>

    <a
      v-show="false"
      ref="formBc"
      href="#"
      data-toggle="modal"
      data-target="#add_form"
      @click="prepareNewForm"
    ></a>
    <a
      v-show="false"
      ref="formBcEdit"
      href="#"
      data-toggle="modal"
      data-target="#add_form"
      @click="activateFormAfterOpen"
    ></a>
    <a
      v-show="false"
      ref="messageModalTrigger"
      href="#"
      data-toggle="modal"
      data-target="#moment_message_modal"
    ></a>

    <form-data :searchData="refreshData" />

    <div id="moment_message_modal" class="modal fade moment-message-modal" role="dialog" aria-labelledby="momentMessageTitle">
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <div class="moment-modal-title">
              <span><i class="fa fa-comment-o"></i></span>
              <div>
                <h5 id="momentMessageTitle" class="modal-title">{{ messageModalRow ? displayName(messageModalRow) : "Pesan Momen" }}</h5>
                <p>{{ messageModalRow && messageModalRow.license_name ? messageModalRow.license_name : "Isi pesan" }}</p>
              </div>
            </div>
            <button type="button" class="close" data-dismiss="modal" aria-label="Tutup">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div v-if="messageModalRow && messageModalRow.image_url && (messageModalRow.message_type == 'image' || messageModalRow.message_type == 'document')" class="moment-modal-attachment">
              <img v-if="messageModalRow.message_type == 'image'" :src="safeUrl(messageModalRow.image_url)" alt="Lampiran gambar" />
              <a v-else :href="safeUrl(messageModalRow.image_url)" target="_blank" rel="noopener">
                <i class="fa fa-file-text-o"></i>
                Lihat lampiran
              </a>
            </div>
            <div class="moment-message-full" v-html="modalMessageHtml"></div>
            <div v-if="!modalMessageHtml" class="moment-message-empty">Pesan masih kosong.</div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn moment-btn moment-btn-secondary" data-dismiss="modal">Tutup</button>
          </div>
        </div>
      </div>
    </div>

    <v-tour name="tourGuide" :steps="tourSteps" :callbacks="tourCallbacks"></v-tour>
  </div>
</template>

<script>
import FormData from "./form.vue";
import Schedule from "./components/schedule.vue";
import Multiselect from "vue-multiselect";
require("vue-multiselect/dist/vue-multiselect.min.css");

import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import {
  convertUTCDatetimeToUnix,
  formatHourFromUnix
} from "@/utils/helper";
import {
  renderWhatsAppHtml,
  whatsappPlainText,
  safeAttachmentUrl
} from "@/utils/whatsappMessage";

export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    Multiselect,
    FormData,
    Schedule
  },
  data() {
    return {
      dataDetailStatus: null,
      statusError: "",
      tourId: "sar.home",
      tourCallbacks: {
        onSkip: this.tourComplete,
        onFinish: this.tourComplete
      },
      tourSteps: [
        {
          target: '[data-tour-step="1"]',
          content: "Halaman Momen Spesial untuk mengelola ucapan dan promo otomatis."
        },
        {
          target: '[data-tour-step="2"]',
          content: "Tambahkan momen baru dengan pesan dan lisensi WhatsApp."
        },
        {
          target: '[data-tour-step="3"]',
          content: "Cari dan filter momen berdasarkan lisensi atau status."
        }
      ],
      selectedTable: [],
      selectedLicense: null,
      contactOptions: [],
      licenseListParam: {
        license_name: "",
        license_phone_number: "",
        license_status: "",
        page: 0,
        perPage: 20
      },
      isLoadingLicense: false,
      isLoading: false,
      loading: false,
      loadError: "",
      rows: [],
      totalRecords: 0,
      currentPage: 1,
      rowPage: 1,
      serverParams: {
        columnFilters: {
          license_id: "",
          message: "",
          message_away: "",
          is_publish: ""
        },
        page: 1,
        perPage: 20
      },
      summaryLoading: false,
      summaryError: "",
      summaryIncomplete: false,
      summaryTotal: null,
      summaryPublished: null,
      summaryDraft: null,
      messageModalRow: null,
      listRequestId: 0,
      summaryRequestId: 0
    };
  },
  computed: {
    selectAllTable: {
      get() {
        return this.rows.length > 0 && this.selectedTable.length === this.rows.length;
      },
      set(value) {
        this.selectedTable = value ? this.rows.slice() : [];
      }
    },
    isConfigured() {
      return Boolean(
        this.dataDetailStatus &&
          this.dataDetailStatus.id !== "" &&
          this.dataDetailStatus.id !== null &&
          typeof this.dataDetailStatus.id !== "undefined"
      );
    },
    isScheduleEnabled() {
      return Boolean(this.isConfigured && Number(this.dataDetailStatus.is_publish) === 1);
    },
    scheduleTime() {
      const raw = this.dataDetailStatus && this.dataDetailStatus.recurrence_time;
      if (!raw) return "";
      if (/^\d{2}:\d{2}$/.test(String(raw))) return String(raw);
      const unix = convertUTCDatetimeToUnix(raw);
      const formatted = formatHourFromUnix(unix);
      return formatted && formatted !== "Invalid date" ? formatted : "";
    },
    hasUpdateDates() {
      return this.rows.some(row => this.updatedAt(row) !== null);
    },
    tableColumnCount() {
      return this.hasUpdateDates ? 7 : 6;
    },
    totalPages() {
      return Math.max(1, Math.ceil(this.totalRecords / this.serverParams.perPage));
    },
    rangeStart() {
      if (!this.totalRecords) return 0;
      return (this.currentPage - 1) * this.serverParams.perPage + 1;
    },
    rangeEnd() {
      return Math.min(this.currentPage * this.serverParams.perPage, this.totalRecords);
    },
    pageNumbers() {
      const total = this.totalPages;
      const current = this.currentPage;
      const max = 5;
      let start = Math.max(1, current - 2);
      let end = Math.min(total, start + max - 1);
      start = Math.max(1, end - max + 1);
      const pages = [];
      for (let page = start; page <= end; page += 1) {
        pages.push(page);
      }
      return pages;
    },
    isFilterActive() {
      return Boolean(
        this.serverParams.columnFilters.license_id ||
          this.serverParams.columnFilters.message ||
          this.serverParams.columnFilters.is_publish
      );
    },
    modalMessageHtml() {
      if (!this.messageModalRow) return "";
      return renderWhatsAppHtml(this.messageModalRow.message);
    }
  },
  watch: {
    selectedLicense(val, oldVal) {
      if (val === oldVal) return;
      this.serverParams.columnFilters.license_id = val && val.id ? val.id : "";
      this.searchData();
    }
  },
  created() {
    this.asyncFindLicense("");
    this.detailStatus();
    this.loadItems();
    this.loadSummary();
    this.tourDetail();
  },
  methods: {
    formatNumber(value) {
      if (value === null || typeof value === "undefined" || value === "") return "—";
      const numeric = Number(value);
      return isFinite(numeric) ? numeric.toLocaleString("id-ID") : "—";
    },
    getErrorMessage(error, fallback) {
      let message = "";
      if (error && error.response && error.response.data) {
        message = error.response.data.msg || error.response.data.message || "";
      }
      if (!message && error && error.message) {
        message = error.message;
      }
      message = String(message)
        .replace(/<br\s*\/?>/gi, " ")
        .replace(/<[^>]*>/g, "")
        .trim();
      if (!message || /sql|select |table|column|backend|redis|worker|stack|trace|invalid|failed|error/i.test(message)) {
        return fallback;
      }
      return message;
    },
    async detailStatus() {
      this.statusError = "";
      try {
        const response = await this.$store.dispatch("birthdayGreetings/detailStatus", {});
        this.dataDetailStatus = (response && response.data) || {};
        return response;
      } catch (error) {
        this.dataDetailStatus = this.dataDetailStatus || {};
        this.statusError = this.getErrorMessage(
          error,
          "Status pengiriman otomatis belum dapat dimuat."
        );
        return null;
      }
    },
    displayName(row) {
      if (!row) return "Momen Spesial";
      const explicit = row.name || row.title || row.moment_name || row.header_name;
      if (explicit) return explicit;
      const plain = whatsappPlainText(row.message || "");
      const firstLine = plain.split(/\r?\n/)[0].trim();
      if (firstLine) return firstLine.slice(0, 90);
      return row.license_name || "Momen Spesial";
    },
    messageHtml(message) {
      return renderWhatsAppHtml(message);
    },
    isLongMessage(row) {
      if (!row || !row.message) return false;
      const plain = whatsappPlainText(row.message);
      return plain.length > 140 || plain.split(/\r?\n/).length > 3;
    },
    messageSnippet(row) {
      if (!row || !row.message) return "";
      const explicitName = row.name || row.title || row.moment_name;
      const raw = String(row.message);
      if (!explicitName) {
        const lines = raw.split(/\r?\n/);
        if (lines.length > 1) {
          return renderWhatsAppHtml(lines.slice(1).join("\n"));
        }
      }
      return renderWhatsAppHtml(raw);
    },
    safeUrl(url) {
      return safeAttachmentUrl(url);
    },
    messagePlain(row) {
      const text = whatsappPlainText(row && row.message ? row.message : "");
      return text.length > 140 ? text.slice(0, 140) + "..." : (text || "Pesan kosong");
    },
    licenseLabel(item) {
      if (!item) return "";
      return item.license_name || item.license_phone_number || "";
    },
    scheduleLabel(row) {
      const raw = (row && row.recurrence_time) || (this.dataDetailStatus && this.dataDetailStatus.recurrence_time);
      if (!raw) return "Belum dijadwalkan";
      let formatted = "";
      if (/^\d{2}:\d{2}$/.test(String(raw))) {
        formatted = String(raw);
      } else {
        const unix = convertUTCDatetimeToUnix(raw);
        const hour = formatHourFromUnix(unix);
        formatted = hour && hour !== "Invalid date" ? hour : "";
      }
      return formatted ? "Setiap hari · " + formatted + " WIB" : "Belum dijadwalkan";
    },
    updatedAt(row) {
      if (!row) return null;
      return (
        row.update_datetime ||
        row.updated_at ||
        row.updated_datetime ||
        row.update_date ||
        row.update_time ||
        row.update_at ||
        row.modified_at ||
        row.last_updated ||
        row.last_update ||
        null
      );
    },
    lastUpdated(row) {
      const value = this.updatedAt(row);
      if (!value) return "—";
      if (typeof value === "number" || /^\d+$/.test(String(value))) {
        const numeric = Number(value);
        const unix = numeric > 9999999999 ? Math.floor(numeric / 1000) : numeric;
        const date = new Date(unix * 1000);
        if (!isNaN(date.getTime())) {
          return date.toLocaleString("id-ID", {
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit"
          });
        }
      }
      const date = new Date(value);
      if (!isNaN(date.getTime())) {
        return date.toLocaleString("id-ID", {
          day: "2-digit",
          month: "short",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit"
        });
      }
      return String(value);
    },
    async asyncFindLicense(query) {
      this.isLoadingLicense = true;
      this.licenseListParam.license_name = query || "";
      try {
        const response = await this.$store.dispatch("license/getLicenseList", this.licenseListParam);
        this.contactOptions = (response && response.data && response.data.data) || [];
      } catch (error) {
        this.contactOptions = [];
      } finally {
        this.isLoadingLicense = false;
      }
    },
    clearMessageSearch() {
      this.serverParams.columnFilters.message = "";
      this.searchData();
    },
    searchData() {
      this.currentPage = 1;
      this.clearSelection();
      this.loadItems();
    },
    resetFilters() {
      this.serverParams.columnFilters.license_id = "";
      this.serverParams.columnFilters.message = "";
      this.serverParams.columnFilters.message_away = "";
      this.serverParams.columnFilters.is_publish = "";
      this.selectedLicense = null;
      this.currentPage = 1;
      this.clearSelection();
      this.loadItems();
    },
    clearSelection() {
      this.selectedTable = [];
    },
    hideActions() {
      this.clearSelection();
    },
    async loadItems() {
      const requestId = this.listRequestId + 1;
      this.listRequestId = requestId;
      this.loading = true;
      this.loadError = "";
      this.clearSelection();
      this.rows = [];

      const params = {
        columnFilters: Object.assign({}, this.serverParams.columnFilters),
        page: Math.max(0, (this.currentPage - 1) * this.serverParams.perPage),
        perPage: this.serverParams.perPage
      };

      try {
        const response = await this.$store.dispatch("birthdayGreetings/list", params);
        if (requestId !== this.listRequestId) return;
        const data = (response && response.data) || {};
        this.totalRecords = Number(data.totalRecords) || 0;
        this.rowPage = data.page;
        this.rows = Array.isArray(data.data) ? data.data : [];
      } catch (error) {
        if (requestId === this.listRequestId) {
          this.loadError = this.getErrorMessage(error, "Daftar momen belum dapat dimuat.");
          this.totalRecords = 0;
        }
      } finally {
        if (requestId === this.listRequestId) {
          this.loading = false;
        }
      }
    },
    async loadSummary() {
      const requestId = this.summaryRequestId + 1;
      this.summaryRequestId = requestId;
      this.summaryLoading = true;
      this.summaryError = "";
      this.summaryIncomplete = false;
      this.summaryPublished = null;
      this.summaryDraft = null;

      try {
        const response = await this.$store.dispatch("birthdayGreetings/list", {
          columnFilters: {
            license_id: "",
            message: "",
            message_away: "",
            is_publish: ""
          },
          page: 0,
          perPage: 1000
        });
        if (requestId !== this.summaryRequestId) return;
        const data = (response && response.data) || {};
        const list = Array.isArray(data.data) ? data.data : [];
        this.summaryTotal = Number(data.totalRecords) || list.length;
        if (list.length < this.summaryTotal) {
          this.summaryIncomplete = true;
          return;
        }
        let published = 0;
        let draft = 0;
        list.forEach(row => {
          if (Number(row.is_publish) === 1) published += 1;
          else if (Number(row.is_publish) === 0) draft += 1;
        });
        this.summaryPublished = published;
        this.summaryDraft = draft;
      } catch (error) {
        if (requestId === this.summaryRequestId) {
          this.summaryError = this.getErrorMessage(error, "Ringkasan momen belum dapat dimuat.");
        }
      } finally {
        if (requestId === this.summaryRequestId) {
          this.summaryLoading = false;
        }
      }
    },
    reloadData() {
      this.loadItems();
      this.loadSummary();
    },
    refreshData() {
      this.currentPage = 1;
      this.clearSelection();
      this.loadItems();
      this.loadSummary();
    },
    async onPageChange(page) {
      if (page < 1 || page > this.totalPages || page === this.currentPage) return;
      this.currentPage = page;
      this.clearSelection();
      await this.loadItems();
    },
    onNextChange() {
      if (this.currentPage < this.totalPages) this.onPageChange(this.currentPage + 1);
    },
    onPrevChange() {
      if (this.currentPage > 1) this.onPageChange(this.currentPage - 1);
    },
    onPerPageChange() {
      this.serverParams.perPage = Number(this.serverParams.perPage) || 20;
      this.currentPage = 1;
      this.clearSelection();
      this.loadItems();
    },
    async openAddMoment() {
      if (!this.isConfigured) {
        this.$fire({
          title: "Aktifkan dulu",
          text: "Aktifkan fitur Momen Spesial dan atur jadwal pengiriman sebelum menambah momen.",
          type: "warning",
          timer: 3500
        });
        return;
      }
      if (this.$refs.formBc) this.$refs.formBc.click();
    },
    prepareNewForm() {
      this.$store.dispatch("birthdayGreetings/setIsShowForm", false);
      this.$store.dispatch("birthdayGreetings/actFormParamSRSt", {
        header: {
          copy: false,
          id: "",
          license_id: "",
          message: "",
          image_url: "",
          is_enable_attach_file: false,
          is_custom_url: false,
          message_type: "text"
        }
      });
      this.activateFormAfterOpen();
    },
    activateFormAfterOpen() {
      setTimeout(() => {
        const modal = document.getElementById("add_form");
        if (modal && modal.classList.contains("show")) {
          this.$store.dispatch("birthdayGreetings/setIsShowForm", true);
        }
      }, 500);
    },
    async detailData(id) {
      if (!id) return;
      this.$store.dispatch("birthdayGreetings/setIsShowForm", false);
      try {
        const response = await this.$store.dispatch("birthdayGreetings/detailForEdit", { id });
        const data = (response && response.data) || {};
        if (data.header) {
          data.header.is_enable_attach_file = Boolean(data.header.image_url);
        }
        await this.$store.dispatch("birthdayGreetings/actFormParamSRSt", data);
        if (this.$refs.formBcEdit) this.$refs.formBcEdit.click();
      } catch (error) {
        this.$fire({
          title: "Gagal",
          text: this.getErrorMessage(error, "Data momen belum dapat dimuat."),
          type: "error",
          timer: 3000
        });
      }
    },
    async copyData(id) {
      if (!id) return;
      this.$store.dispatch("birthdayGreetings/setIsShowForm", false);
      try {
        const response = await this.$store.dispatch("birthdayGreetings/detailForEdit", { id });
        const data = (response && response.data) || {};
        if (!data.header) data.header = {};
        data.header.copy = true;
        data.header.is_publish = 0;
        await this.$store.dispatch("birthdayGreetings/actFormParamSRSt", data);
        if (this.$refs.formBcEdit) this.$refs.formBcEdit.click();
      } catch (error) {
        this.$fire({
          title: "Gagal",
          text: this.getErrorMessage(error, "Momen belum dapat diduplikasi."),
          type: "error",
          timer: 3000
        });
      }
    },
    async draftData(row) {
      if (!row || !row.id) return;
      this.isLoading = true;
      try {
        const response = await this.$store.dispatch("birthdayGreetings/updateDraft", { id: row.id });
        this.$fire({
          title: "Berhasil",
          text: (response && response.msg) || "Momen berhasil diubah ke Draft.",
          type: "success",
          timer: 2500
        });
        this.refreshData();
      } catch (error) {
        this.$fire({
          title: "Gagal",
          text: this.getErrorMessage(error, "Status momen belum dapat diubah."),
          type: "error",
          timer: 3000
        });
      } finally {
        this.isLoading = false;
      }
    },
    async publishData(row) {
      if (!row || !row.id) return;
      this.isLoading = true;
      try {
        const response = await this.$store.dispatch("birthdayGreetings/updatePublish", { id: row.id });
        this.$fire({
          title: "Berhasil",
          text: (response && response.msg) || "Momen berhasil dipublikasikan.",
          type: "success",
          timer: 2500
        });
        this.refreshData();
      } catch (error) {
        this.$fire({
          title: "Gagal",
          text: this.getErrorMessage(error, "Momen belum dapat dipublikasikan."),
          type: "error",
          timer: 3000
        });
      } finally {
        this.isLoading = false;
      }
    },
    async deleteData(row) {
      if (!row || !row.id) return;
      const confirmation = await this.$fire({
        title: "Hapus momen ini?",
        text: (row.license_name || displayName(row)) + " akan dihapus. Tindakan ini tidak dapat dibatalkan.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Hapus",
        cancelButtonText: "Batal",
        confirmButtonColor: "#d92d20"
      });
      if (!confirmation || !(confirmation.isConfirmed || confirmation.value === true)) return;
      try {
        const response = await this.$store.dispatch("birthdayGreetings/deleteData", { id: row.id });
        this.$fire({
          title: "Berhasil",
          text: (response && response.msg) || "Momen berhasil dihapus.",
          type: "success",
          timer: 2500
        });
        this.refreshData();
      } catch (error) {
        this.$fire({
          title: "Gagal",
          text: this.getErrorMessage(error, "Momen belum dapat dihapus."),
          type: "error",
          timer: 3000
        });
      }
    },
    async bulkStatus(action, title, successText) {
      if (!this.selectedTable.length) {
        this.$fire({ title: "Peringatan", text: "Pilih minimal satu momen.", type: "warning", timer: 2500 });
        return;
      }
      const confirmation = await this.$fire({
        title: title + "?",
        text: "Status " + this.selectedTable.length + " momen akan diubah.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Ya",
        cancelButtonText: "Batal",
        confirmButtonColor: "#f39c12"
      });
      if (!confirmation || !(confirmation.isConfirmed || confirmation.value === true)) return;
      this.isLoading = true;
      try {
        const response = await this.$store.dispatch("birthdayGreetings/" + action, { id: this.selectedTable });
        this.$fire({ title: "Berhasil", text: (response && response.msg) || successText, type: "success", timer: 2500 });
        this.clearSelection();
        this.refreshData();
      } catch (error) {
        this.$fire({ title: "Gagal", text: this.getErrorMessage(error, "Status momen belum dapat diubah."), type: "error", timer: 3000 });
      } finally {
        this.isLoading = false;
      }
    },
    actionDraft() {
      this.bulkStatus("actionDraft", "Ubah ke Draft", "Momen berhasil diubah ke Draft.");
    },
    actionPublish() {
      this.bulkStatus("actionPublish", "Publikasikan momen", "Momen berhasil dipublikasikan.");
    },
    async actionDelete() {
      if (!this.selectedTable.length) return;
      const confirmation = await this.$fire({
        title: "Hapus " + this.selectedTable.length + " momen?",
        text: "Momen yang dipilih akan dihapus permanen.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Hapus",
        cancelButtonText: "Batal",
        confirmButtonColor: "#d92d20"
      });
      if (!confirmation || !(confirmation.isConfirmed || confirmation.value === true)) return;
      this.isLoading = true;
      try {
        const response = await this.$store.dispatch("birthdayGreetings/actionDelete", { id: this.selectedTable });
        this.$fire({ title: "Berhasil", text: (response && response.msg) || "Momen berhasil dihapus.", type: "success", timer: 2500 });
        this.clearSelection();
        this.refreshData();
      } catch (error) {
        this.$fire({ title: "Gagal", text: this.getErrorMessage(error, "Momen belum dapat dihapus."), type: "error", timer: 3000 });
      } finally {
        this.isLoading = false;
      }
    },
    showMessage(row) {
      this.messageModalRow = row;
      this.$nextTick(() => {
        if (this.$refs.messageModalTrigger) {
          this.$refs.messageModalTrigger.click();
        }
      });
    },
    tourShow() {
      if (this.$tours && this.$tours["tourGuide"]) this.$tours["tourGuide"].start();
    },
    tourComplete() {
      this.$store.dispatch("tour/tourComplete", { tour_id: this.tourId });
    },
    tourDetail() {
      this.$store.dispatch("tour/tourDetail", { tour_id: this.tourId }).then(response => {
        const data = response && response.data;
        if (data && data.id == "") this.tourShow();
      });
    }
  },
  name: "bdgreetings-list"
};
</script>

<style scoped>
.moment-page-content {
  padding-bottom: 32px;
  color: #344054;
}

.moment-page-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
  flex-wrap: wrap;
  margin-bottom: 20px;
}

.moment-eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  margin-bottom: 6px;
  color: #b36b00;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.moment-head-copy h3 {
  margin: 0 0 6px;
  color: #101828;
  font-size: 28px;
  font-weight: 700;
  line-height: 1.25;
}

.moment-head-copy p {
  margin: 0 0 9px;
  color: #667085;
  font-size: 14px;
  line-height: 1.5;
}

.moment-head-copy .breadcrumb {
  margin: 0;
  padding: 0;
  background: transparent;
  font-size: 13px;
}

.moment-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  height: 38px;
  padding: 0 14px;
  border-radius: 9px;
  border: 1px solid transparent;
  font-size: 13px;
  font-weight: 700;
  white-space: nowrap;
}

.moment-btn-primary {
  color: #ffffff;
  background: #f39c12;
  border-color: #f39c12;
  box-shadow: 0 3px 8px rgba(243, 156, 18, 0.18);
}

.moment-btn-primary:hover,
.moment-btn-primary:focus {
  color: #ffffff;
  background: #e08b13;
  border-color: #e08b13;
}

.moment-btn-primary.is-disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.moment-btn-secondary {
  color: #475467;
  background: #ffffff;
  border-color: #e7edf5;
}

.moment-btn-secondary:hover,
.moment-btn-secondary:focus {
  color: #b36b00;
  background: #fffaf0;
  border-color: #f6d49b;
}

.moment-btn-danger {
  color: #ffffff;
  background: #d92d20;
  border-color: #d92d20;
}

.moment-btn-danger:hover,
.moment-btn-danger:focus {
  color: #ffffff;
  background: #b42318;
  border-color: #b42318;
}

.moment-btn-ghost {
  color: #667085;
  background: transparent;
  border-color: transparent;
}

.moment-stat-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 14px;
  margin: 16px 0;
}

.moment-stat-card {
  display: flex;
  align-items: flex-start;
  gap: 11px;
  min-width: 0;
  padding: 15px;
  background: #ffffff;
  border: 1px solid #e7edf5;
  border-radius: 14px;
  box-shadow: 0 2px 8px rgba(16, 24, 40, 0.03);
}

.moment-stat-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 40px;
  width: 40px;
  height: 40px;
  border-radius: 11px;
  font-size: 17px;
}

.moment-stat-icon.is-orange { color: #e08b13; background: #fff7e8; }
.moment-stat-icon.is-green { color: #12b76a; background: #ecfdf3; }
.moment-stat-icon.is-amber { color: #d98314; background: #fffaeb; }
.moment-stat-icon.is-blue { color: #2e90fa; background: #eff8ff; }

.moment-stat-copy {
  min-width: 0;
}

.moment-stat-copy > span {
  display: block;
  color: #667085;
  font-size: 12px;
  font-weight: 600;
}

.moment-stat-copy > strong {
  display: block;
  margin: 2px 0;
  color: #101828;
  font-size: 24px;
  line-height: 1.2;
  font-weight: 700;
}

.moment-stat-copy > strong.stat-on { color: #067647; }
.moment-stat-copy > strong.stat-off { color: #b36b00; }

.moment-stat-copy > small {
  display: block;
  overflow: hidden;
  color: #98a2b3;
  font-size: 11px;
  line-height: 1.4;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.moment-card {
  background: #ffffff;
  border: 1px solid #e7edf5;
  border-radius: 14px;
  box-shadow: 0 2px 8px rgba(16, 24, 40, 0.03);
}

.moment-toolbar {
  margin-bottom: 16px;
  padding: 14px;
}

.moment-toolbar-row {
  display: flex;
  align-items: center;
  gap: 9px;
  flex-wrap: wrap;
}

.moment-search {
  position: relative;
  display: flex;
  align-items: center;
  flex: 1 1 280px;
  min-width: 220px;
  height: 40px;
  padding: 0 11px;
  color: #98a2b3;
  background: #f8fafc;
  border: 1px solid #e7edf5;
  border-radius: 9px;
}

.moment-search > i { flex: 0 0 auto; font-size: 14px; }

.moment-search input {
  width: 100%;
  min-width: 0;
  height: 100%;
  padding: 0 8px;
  color: #344054;
  background: transparent;
  border: 0;
  outline: none;
  font-size: 14px;
}

.moment-search input::placeholder { color: #98a2b3; }

.moment-search-clear {
  padding: 3px;
  color: #98a2b3;
  background: transparent;
  border: 0;
  font-size: 13px;
}

.moment-search-clear:hover { color: #b42318; }

.moment-license-filter {
  flex: 0 1 230px;
  min-width: 190px;
}

.moment-license-filter /deep/ .multiselect {
  min-height: 40px;
  color: #475467;
  border: 1px solid #e7edf5;
  border-radius: 9px;
  font-size: 13px;
}

.moment-license-filter /deep/ .multiselect__tags {
  min-height: 38px;
  padding: 8px 36px 0 11px;
  background: #ffffff;
  border: 0;
  border-radius: 9px;
}

.moment-license-filter /deep/ .multiselect__input,
.moment-license-filter /deep/ .multiselect__single {
  font-size: 13px;
}

.moment-license-filter /deep/ .multiselect__content-wrapper {
  border: 1px solid #e7edf5;
  border-radius: 10px;
  box-shadow: 0 14px 30px rgba(15, 23, 42, 0.12);
}

.moment-option-phone {
  margin-left: 6px;
  color: #98a2b3;
  font-size: 11px;
}

.moment-status-filter select {
  height: 40px;
  min-width: 145px;
  padding: 0 30px 0 11px;
  color: #475467;
  background: #ffffff;
  border: 1px solid #e7edf5;
  border-radius: 9px;
  font-size: 13px;
}

.moment-bulk-bar {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  margin-top: 12px;
  padding: 10px 12px;
  color: #8f5600;
  background: #fffaf1;
  border: 1px solid #f6d49b;
  border-radius: 10px;
  font-size: 13px;
}

.moment-bulk-bar > span { flex: 1 1 auto; }
.moment-bulk-bar strong { color: #b36b00; }

.moment-inline-note {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  flex-wrap: wrap;
  margin-bottom: 14px;
  padding: 10px 14px;
  color: #475467;
  background: #f8fafc;
  border: 1px solid #e7edf5;
  border-radius: 10px;
  font-size: 13px;
}

.moment-inline-note.is-warning {
  color: #8a5a00;
  background: #fff8e6;
  border-color: #f3d28d;
}

.moment-inline-note.is-error {
  color: #a71d2a;
  background: #fff5f5;
  border-color: #f5b5b5;
}

.moment-link-btn {
  padding: 0;
  color: inherit;
  background: transparent;
  border: 0;
  font-weight: 700;
  text-decoration: underline;
}

.moment-table-card { overflow: visible; }
.moment-table-wrap { overflow: visible; }

.moment-table {
  width: 100%;
  min-width: 860px;
  margin-bottom: 0;
  color: #475467;
  font-size: 14px;
  line-height: 1.45;
}

.moment-table thead th {
  padding: 12px 14px;
  color: #667085;
  background: #f8fafc;
  border-top: 0;
  border-bottom: 1px solid #e7edf5;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  white-space: nowrap;
}

.moment-table tbody td {
  padding: 14px;
  vertical-align: top;
  border-bottom: 1px solid #f1f4f8;
}

.moment-table tbody tr:last-child td { border-bottom: 0; }
.moment-table tbody tr:hover { background: #fffdf9; }

.moment-check-col {
  width: 42px;
  text-align: center;
}

.moment-check-col input {
  width: 16px;
  height: 16px;
  cursor: pointer;
}

.moment-name {
  color: #344054;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.4;
  word-break: break-word;
}

.moment-message {
  display: -webkit-box;
  overflow: hidden;
  max-width: 390px;
  margin-top: 3px;
  color: #667085;
  font-size: 12px;
  line-height: 1.5;
  word-break: break-word;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.moment-message /deep/ strong { font-weight: 700; }
.moment-message /deep/ em { font-style: italic; }
.moment-message /deep/ s { text-decoration: line-through; }
.moment-message /deep/ code { font-family: Consolas, Monaco, monospace; }

.moment-message-more {
  margin-top: 2px;
  padding: 0;
  color: #b36b00;
  background: transparent;
  border: 0;
  font-size: 11px;
  font-weight: 700;
}

.moment-message-more:hover { text-decoration: underline; }

.moment-mobile-meta {
  display: none;
}

.moment-license-name {
  color: #475467;
  font-size: 13px;
  font-weight: 600;
}

.moment-license-phone {
  display: block;
  margin-top: 2px;
  color: #98a2b3;
  font-size: 11px;
}

.moment-schedule {
  display: inline-flex;
  align-items: flex-start;
  gap: 5px;
  max-width: 150px;
  color: #667085;
  font-size: 12px;
  line-height: 1.45;
}

.moment-schedule i { margin-top: 2px; color: #98a2b3; }

.moment-status-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 8px;
  border: 1px solid transparent;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  white-space: nowrap;
}

.moment-status-badge.is-published {
  color: #067647;
  background: #ecfdf3;
  border-color: #bbf7d0;
}

.moment-status-badge.is-draft {
  color: #8a5a00;
  background: #fffaeb;
  border-color: #f3d28d;
}

.moment-updated {
  color: #667085;
  font-size: 12px;
  white-space: nowrap;
}

.moment-action-col {
  width: 68px;
  text-align: right;
}

.moment-row-actions { display: inline-block; }

.moment-action-toggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  padding: 0;
  color: #667085;
  background: #ffffff;
  border: 1px solid #e7edf5;
  border-radius: 9px;
  font-size: 15px;
}

.moment-action-toggle:hover,
.moment-action-toggle:focus {
  color: #b36b00;
  background: #fffaf0;
  border-color: #f6d49b;
  outline: none;
}

.moment-row-actions .dropdown-menu {
  min-width: 220px;
  padding: 7px;
  border: 1px solid #e7edf5;
  border-radius: 12px;
  box-shadow: 0 16px 34px rgba(15, 23, 42, 0.16);
}

.moment-row-actions .dropdown-item {
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 9px 10px;
  color: #475467;
  border-radius: 8px;
  font-size: 13px;
}

.moment-row-actions .dropdown-item:hover,
.moment-row-actions .dropdown-item:focus {
  color: #b36b00;
  background: #fffaf1;
}

.moment-row-actions .moment-danger-item { color: #b42318; }
.moment-row-actions .moment-danger-item:hover,
.moment-row-actions .moment-danger-item:focus { color: #912018; background: #fff1f0; }

.moment-skeleton-row {
  display: flex;
  align-items: center;
  gap: 16px;
}

.moment-skeleton {
  display: block;
  height: 15px;
  background: #eef2f6;
  border-radius: 6px;
}

.moment-skeleton-check { width: 16px; height: 16px; }
.moment-skeleton-name { width: 160px; }
.moment-skeleton-message { width: 280px; }

.moment-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 46px 16px;
  text-align: center;
}

.moment-empty-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  margin-bottom: 12px;
  color: #e08b13;
  background: #fff7e8;
  border: 1px solid #f6d49b;
  border-radius: 50%;
  font-size: 21px;
}

.moment-empty-icon.is-error {
  color: #b42318;
  background: #fff1f0;
  border-color: #f5b5b5;
}

.moment-empty strong {
  margin-bottom: 4px;
  color: #344054;
  font-size: 17px;
}

.moment-empty p {
  max-width: 420px;
  margin: 0 0 15px;
  color: #667085;
  font-size: 13px;
}

.moment-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  flex-wrap: wrap;
  padding: 14px 16px;
  border-top: 1px solid #f1f4f8;
}

.moment-pagination-info {
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
  color: #667085;
  font-size: 13px;
}

.moment-pagination-info strong { color: #344054; }

.moment-per-page {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 0;
  font-weight: 400;
}

.moment-per-page select {
  height: 32px;
  padding: 0 24px 0 9px;
  color: #475467;
  background: #ffffff;
  border: 1px solid #e7edf5;
  border-radius: 8px;
  font-size: 13px;
}

.moment-pagination-buttons {
  display: flex;
  align-items: center;
  gap: 5px;
}

.moment-page-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 34px;
  height: 34px;
  padding: 0 8px;
  color: #475467;
  background: #ffffff;
  border: 1px solid #e7edf5;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
}

.moment-page-btn:hover:not(:disabled),
.moment-page-btn:focus:not(:disabled) {
  color: #b36b00;
  background: #fffaf0;
  border-color: #f6d49b;
  outline: none;
}

.moment-page-btn.active {
  color: #ffffff;
  background: #f39c12;
  border-color: #f39c12;
}

.moment-page-btn:disabled {
  color: #b8c0cc;
  background: #f8fafc;
  cursor: not-allowed;
}

.moment-page-note {
  margin-top: 14px;
  color: #667085;
  font-size: 12px;
  line-height: 1.55;
}

.moment-page-note i { margin-right: 5px; color: #2e90fa; }

.moment-message-modal .modal-content {
  overflow: hidden;
  border: 1px solid #e7edf5;
  border-radius: 16px;
}

.moment-message-modal .modal-header {
  align-items: flex-start;
  padding: 18px 20px;
  border-bottom: 1px solid #eef1f4;
}

.moment-modal-title {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.moment-modal-title > span {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  color: #b36b00;
  background: #fff7e8;
  border: 1px solid #f6d49b;
  border-radius: 10px;
  font-size: 17px;
}

.moment-modal-title h5 {
  margin: 0 0 2px;
  color: #101828;
  font-size: 18px;
  font-weight: 700;
}

.moment-modal-title p {
  margin: 0;
  color: #667085;
  font-size: 12px;
}

.moment-message-full {
  color: #344054;
  font-size: 14px;
  line-height: 1.7;
  overflow-wrap: anywhere;
}

.moment-message-full /deep/ strong { font-weight: 700; }
.moment-message-full /deep/ em { font-style: italic; }
.moment-message-full /deep/ s { text-decoration: line-through; }
.moment-message-full /deep/ code { padding: 1px 4px; background: #f2f4f7; border-radius: 4px; font-family: Consolas, Monaco, monospace; }

.moment-message-empty {
  color: #98a2b3;
  font-size: 13px;
  font-style: italic;
}

.moment-modal-attachment {
  margin-bottom: 12px;
}

.moment-modal-attachment img {
  display: block;
  max-width: 100%;
  max-height: 260px;
  margin: 0 auto;
  border-radius: 9px;
}

.moment-modal-attachment a {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 9px 11px;
  color: #475467;
  background: #f8fafc;
  border: 1px solid #e7edf5;
  border-radius: 8px;
  font-size: 13px;
}

.moment-modal-attachment a:hover { color: #b36b00; }

@media (max-width: 1200px) {
  .moment-table-wrap { overflow-x: auto; }
}

@media (max-width: 991px) {
  .moment-stat-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .moment-row-actions .dropdown-menu {
    position: fixed !important;
    top: auto !important;
    right: 12px !important;
    bottom: 12px !important;
    left: 12px !important;
    width: auto !important;
    min-width: 0 !important;
    max-height: calc(100vh - 24px);
    margin: 0 !important;
    overflow-y: auto;
    transform: none !important;
    z-index: 1080;
  }
}

@media (max-width: 767px) {
  .moment-page-head { flex-direction: column; }
  .moment-page-head .moment-btn-primary { align-self: flex-start; }
  .moment-stat-grid { grid-template-columns: minmax(0, 1fr); }
  .moment-toolbar-row { align-items: stretch; }
  .moment-search { flex-basis: 100%; }
  .moment-license-filter { flex: 1 1 100%; min-width: 0; }
  .moment-status-filter select { width: 100%; }
  .moment-toolbar-row .moment-btn { flex: 1 1 auto; }
  .moment-pagination { align-items: flex-start; flex-direction: column; }
  .moment-pagination-buttons { flex-wrap: wrap; }
  .moment-message { max-width: none; }

  .moment-table-wrap {
    overflow: visible;
  }

  .moment-table {
    width: 100%;
    min-width: 0;
  }

  .moment-table thead th,
  .moment-table tbody td {
    padding: 11px 7px;
  }

  .moment-table .moment-license-col,
  .moment-table .moment-schedule-col,
  .moment-table .moment-updated-col {
    display: none;
  }

  .moment-mobile-meta {
    display: flex;
    flex-direction: column;
    gap: 2px;
    margin-top: 5px;
    color: #98a2b3;
    font-size: 10px;
    line-height: 1.4;
  }

  .moment-mobile-meta span {
    display: flex;
    align-items: flex-start;
    gap: 4px;
  }

  .moment-mobile-meta i {
    margin-top: 2px;
    color: #b0b8c4;
  }

  .moment-check-col {
    width: 32px;
  }

  .moment-status-badge {
    padding: 3px 6px;
    font-size: 10px;
  }

  .moment-action-col {
    width: 44px;
  }

  .moment-action-toggle {
    width: 32px;
    height: 32px;
    font-size: 14px;
  }

  .moment-message-modal .modal-content { max-height: calc(100vh - 16px); overflow-y: auto; }
}

@media (max-width: 480px) {
  .moment-head-copy h3 { font-size: 24px; }
  .moment-stat-copy > strong { font-size: 22px; }
  .moment-pagination-info { align-items: flex-start; flex-direction: column; gap: 8px; }
  .moment-per-page { flex-wrap: wrap; }
  .moment-bulk-bar .moment-btn { flex: 1 1 auto; }
}
</style>



// WEBPACK FOOTER //
// src/views/automation/birthdayGreetings/list.vue